/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemHeartWrapper_item = {
    readonly serviceId: string | null;
    readonly heartPortfolioItems?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"Heart_heartPortfolioItems">;
    } | null> | null;
    readonly " $refType": "ItemHeartWrapper_item";
};
export type ItemHeartWrapper_item$data = ItemHeartWrapper_item;
export type ItemHeartWrapper_item$key = {
    readonly " $data"?: ItemHeartWrapper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemHeartWrapper_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemHeartWrapper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "loadPortfolioData",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "heartPortfolioItems",
          "name": "portfolioItems",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "portfolioType",
              "value": "HEART"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "PortfolioItemV2",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Heart_heartPortfolioItems",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '3cc9f9f07351654ffe5a68f9eb6b5ae3';
export default node;
